import React, { useState } from 'react'
import { IconButton, Tooltip, makeStyles } from '@material-ui/core'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'
import axios from 'axios'
import { useLanguage } from '../../../../lib/hooks/languageHooks'

const useStyles = makeStyles(() => ({
    iconButton: {
        padding: 4
    },
}))

const ReportButton = ({ productId }) => {
    const classes = useStyles()
    const lang = useLanguage()
    const [downloading, setDownloading] = useState(false)

    const downloadReport = () => {
        setDownloading(true);
        (async () => {
            let data = undefined
            let statusCode = 0

            try {
                const response = await axios.get(`/api/ProductInfo/GetProductReport?id=${productId}&language=${lang}`, { responseType: 'blob' })
                    .then(resp => {
                        data = resp.data
                        statusCode = resp.status
                    }).catch(err => {
                        if (err.response) {
                            statusCode = err.response.status
                        }
                    })
            } catch (error) {
                console.log('Error fetching data with axios')
            }

            setDownloading(false)

            if (statusCode !== 200)
                return

            const url = window.URL.createObjectURL(new Blob([data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${productId}_${lang}.pdf`)
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
        })()
    }

    return (
        <Tooltip title='Skapa PDF-rapport'>
            <IconButton className={classes.iconButton} onClick={downloadReport} disabled={downloading}>
                <PictureAsPdfIcon />
            </IconButton>
        </Tooltip>
    )
}

export default ReportButton
